import { Routes } from '@angular/router';
import { CustomerSelectionContainerComponent } from 'app/00_modules/organisation/customers/customer-selection.container';
import { PartnerSelectionContainerComponent } from 'app/00_modules/organisation/partners/partner-selection.dialog';
import { UserRoleSelectionContainerComponent } from 'app/00_modules/organisation/users/userroleselection.container';
import { PageNotFoundContainerComponent } from 'app/00_modules/shared/components/containers/pagenotfound.container';
import { RoleResolver } from 'app/resolvers/role.resolver';
import { GuardAuthentication } from './00_modules/core/guards/guardAuthentication';
import { GuardMasterDataManager } from './00_modules/core/guards/guardMasterDataManager';
import { GuardOrdering } from './00_modules/core/guards/guardOrdering';
import { RoleRedirectGuard } from './00_modules/core/guards/role-redirect.guard';
import { CommonRoutingSegments } from './00_modules/core/services/common-routing-segments';
import { JeWaitComponent } from './00_modules/shared/components/wait/wait.component';
import { LoginComponent } from './login/login.component';
import { GuardClassicCarsDataManager } from './00_modules/core/guards/guardClassicCarsDataManager';

export const APP_ROUTES: Routes = [
    { path: CommonRoutingSegments.Login, component: LoginComponent },
    {
        path: CommonRoutingSegments.Password,
        loadChildren: () => import('app/00_modules/password/password.routes').then(m => m.PASSWORD_ROUTES),
    },
    {
        path: CommonRoutingSegments.Order,
        loadChildren: () => import('app/domain/ordering/ordering.routes').then(m => m.ORDERING_ROUTES),
        canLoad: [GuardOrdering],
    },
    {
        path: CommonRoutingSegments.MasterData,
        loadChildren: () => import('app/00_modules/master-data/master-data.routes').then(m => m.MASTER_DATA_ROUTES),
        canLoad: [GuardMasterDataManager],
        canActivate: [GuardAuthentication],
    },
    {
        path: CommonRoutingSegments.ClassicCars,
        loadChildren: () => import('app/pages/classic-cars.routes').then(m => m.CLASSIC_CARS_ROUTES),
        canLoad: [GuardClassicCarsDataManager],
        canActivate: [GuardAuthentication],
    },
    {
        path: CommonRoutingSegments.CustomerSelection,
        component: CustomerSelectionContainerComponent,
        canActivate: [GuardAuthentication, RoleRedirectGuard],
    },
    {
        path: CommonRoutingSegments.RoleSelection,
        component: UserRoleSelectionContainerComponent,
        canActivate: [GuardAuthentication],
    },
    {
        path: CommonRoutingSegments.PartnerSelection,
        component: PartnerSelectionContainerComponent,
        canActivate: [GuardAuthentication],
    },
    {
        path: CommonRoutingSegments.Dashboard,
        loadChildren: () => import('app/00_modules/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
        resolve: { empty: RoleResolver },
        canActivate: [GuardAuthentication],
    },
    {
        path: CommonRoutingSegments.UserProfile,
        loadChildren: () => import('app/00_modules/user-profile/user-profile.routes').then(m => m.USER_PROFILE_ROUTES),
        canActivate: [GuardAuthentication],
    },
    { path: CommonRoutingSegments.Wait, component: JeWaitComponent },
    {
        path: 'integration',
        loadChildren: () => import('app/00_modules/integration/integration.routes').then(m => m.INTEGRATION_ROUTES),
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: CommonRoutingSegments.Dashboard,
    },
    { path: '**', component: PageNotFoundContainerComponent },
];
